import {CuiNavbarComponent} from '@cicero/webui/lib/navigation/navbar';
import {Component, ViewChild} from '@angular/core';

@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.scss']
})
export class UserManualComponent {

  @ViewChild(CuiNavbarComponent)
  navbar: CuiNavbarComponent;

  goTo(fragment: string) {
    window.location.hash = '';
    window.location.hash = fragment;
    this.navbar.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/help/user-manual/user-manual.component.ts